import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { Server } from '@reporting/rp-types/core';
import { DbFile } from '@reporting/rp-types/server';

/** Dropdown key of a database node: `<id_server>-<db_name>`, the same chunks the `super-tables-…` component id carries. */
export const databaseKey = (idServer: number, dbName: string) => `${idServer}-${dbName}`;

export class ServerTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	constructor(
		private options?: Partial<TreeOptions>,
		private showAllItem: boolean = false,
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
        this.items = [];
		const servers = await rp.ms('server').get<Server[]>('servers');
		for (const s of servers) {
			if (!this.items.find(i => i.v === s.host)) {
                this.items.push({
                    k: `${s.id_server}`,
                    v: s.host,
                });
			}
		}
		if (this.showAllItem) {
			this.items.unshift({ k: null, v: `<${msg('all')}>` });
		}
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}
}


export class DatabaseTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	constructor(
		private options?: Partial<TreeOptions>,
		private showAllItem: boolean = false,
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
        this.items = [];
		// one row per server and database (super, master and data databases), ordered by host
		const databases = await rp.ms('server').get<DbFile[]>('databases');
		let prev: DbFile;
		for (const d of databases) {
			if (!prev || prev.host !== d.host) {
				this.items.push({
					l: 0,
					k: d.host,
					v: d.host,
					ch: false,
					collapsed: true,
					folder: { openIcon: 'folder-open', closedIcon: 'folder-closed' }
				});
			}
			this.items.push({
				l: 1,
				k: databaseKey(d.id_server, d.db_name),
				v: d.db_name,
				props: { id_server: d.id_server, db_name: d.db_name, db_type: d.db_type }
			});
			prev = d;
		}
		if (this.showAllItem) {
			this.items.unshift({ k: null, v: `<${msg('all')}>` });
		}
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}
}
